import { render, staticRenderFns } from "./Super.vue?vue&type=template&id=c0ad143a&scoped=true"
import script from "./Super.vue?vue&type=script&lang=js"
export * from "./Super.vue?vue&type=script&lang=js"
import style0 from "./Super.vue?vue&type=style&index=0&id=c0ad143a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ad143a",
  null
  
)

export default component.exports